import { Container, Grid, Typography, makeStyles } from '@material-ui/core'

import { FC, useEffect, useState, useRef } from 'react'
import Panel from '../component/um/settingDocument/Panel'
import useTranslate from '../i18n/useTranslate'

import {
    DocumentResponseSearch,
    SearchDocumentRequest,
    SearchDocumentResponse,
    useSettingDocument,
} from '../services/um/useSettingDocument'

import useLoadingStore from '../control/loading/store/useLoadingStore'
import useAuthenStore from '../stores/authen/authenStore'
import { useQueryParam } from 'use-query-params'
import { FormApi } from 'final-form'

import Draggables from '../component/um/settingDocument/Draggables'
import Dialog, { DialogType } from '../control/dialog/dialog'
import SearchAccordion from '../control/accordion/SearchAccordion'

interface SettingDocumentProps {}

export type DocumentType = {
    document: SearchDocumentResponse[]
}

export type SettingDocumentSearchform = {
    rec: number | null
    submittedType: string | null
}
const SettingDocument: FC<SettingDocumentProps> = ({}) => {
    const classes = useStyles()
    const translate = useTranslate()
    const loadingStore = useLoadingStore()
    const authenStore = useAuthenStore()
    const [dataList, setDataList] = useState<DocumentResponseSearch>({ data: [], total: 0 })
    const { getSearchSettingDocument, putOrderSettingDocument } = useSettingDocument()
    const [rec, setRec] = useQueryParam<number | null>('rec')
    const [submittedType, setSubmittedType] = useQueryParam<string | null>('submittedType')
    const [isDragDisabled, setIsDragDisabled] = useState<boolean>(true)

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    const [initialValue, setInitialValue] = useState<SettingDocumentSearchform>({
        rec: (authenStore.profile.irb || rec) ?? null,
        submittedType: submittedType ?? '1',
    })

    useEffect(() => {
        if (authenStore.profile.userId) {
            setRec(authenStore.profile.irb)
            setSubmittedType(submittedType ? submittedType : '1')
            initialLoad()
        }
    }, [authenStore.profile.userId])

    const initialLoad = async () => {
        let param: SearchDocumentRequest = {
            userID: authenStore.profile.userId ?? 0,
            recID: authenStore.profile.irb,
            submittedTypeID: submittedType ? submittedType : '1',
        }
        loadData(param)
    }

    const onSubmit = (values: SettingDocumentSearchform) => {
        let param: SearchDocumentRequest = {
            userID: authenStore.profile.userId ?? 0,
            recID: rec,
            submittedTypeID: values.submittedType ?? null,
        }
        loadData(param)
        setSearchParam(values)
        setInitialValue(values)
    }

    const loadData = async (param: SearchDocumentRequest) => {
        const result = await getSearchSettingDocument(param)
        setDataList(result)
    }

    const setSearchParam = (value: SettingDocumentSearchform) => {
        setRec(value.rec)
        setSubmittedType(value.submittedType ? value.submittedType.toString() : null)
    }

    const onReset = (form: FormApi<SettingDocumentSearchform, Partial<SettingDocumentSearchform>>) => {
        let param = {
            rec: rec,
            submittedType: '1',
        }
        form.initialize(param)
        setInitialValue(param)
        loadData({ userID: authenStore.profile.userId ?? 0, recID: rec, submittedTypeID: '1' })
    }

    const handleOrderNumberMode = () => {
        setIsDragDisabled(!isDragDisabled)
        initialLoad()
    }

    const handleOrder = (value: DocumentType) => {
        setConfigDialog({
            title: `${translate.get('UM.SETTINGDOCUMENT.MESSAGE.HEADER')}`,
            content: `${translate.get('UM.SETTINGDOCUMENT.MESSAGE.CONFIRM')}`,
            type: 'alert-confirm',
            onClickConfirm: () => onSave(value),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onSave = async (value: DocumentType) => {
        let params = value.document.map((item) => item.documentID)
        const result = await putOrderSettingDocument(params, authenStore.profile.userId ?? 0, submittedType ?? null)

        if (result.message === 'success') {
            setConfigDialog({
                title: `${translate.get('UM.SETTINGDOCUMENT.MESSAGE.HEADER')}`,
                content: `${translate.get('UM.SETTINGDOCUMENT.MESSAGE.SUCCESS')}`,
                type: 'alert-message',
            })
            dialogTwoRef.current?.openDialog()
            handleOrderNumberMode()
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    return (
        <Container maxWidth="lg">
            <Grid className={classes.root}>
                <Grid item xs={12}>
                    <SearchAccordion title={translate.get('LABEL.SETTINGDOCUMENT')}>
                        <Panel onSubmit={onSubmit} initialValue={initialValue} onReset={onReset} />
                    </SearchAccordion>
                </Grid>

                <Grid item xs={12}>
                    <Draggables
                        handleOrder={handleOrder}
                        isDragDisabled={isDragDisabled}
                        handleOrderNumberMode={handleOrderNumberMode}
                        dataList={dataList}
                        reLoadData={loadData}
                    />
                </Grid>

                {!loadingStore.isLoading && dataList.total === 0 && (
                    <Grid
                        container
                        item
                        alignContent="center"
                        justify="center"
                        style={{ border: '1px solid rgba(0, 0, 0, .125)' }}
                    >
                        <Typography variant="h6">{translate.get('LABEL.NO_DATA_FOUND')}</Typography>
                    </Grid>
                )}
            </Grid>

            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}

export default SettingDocument

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    textResult: {
        margin: '8px 0',
    },

    buttonSection: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    select: {
        height: 40,
    },
    sorting: {
        marginLeft: '5px',
    },
}))
